import React from 'react';
import Messages from '../../../../../../../Localization/Messages';
import { formatMessage } from '../../../../../../../Localization/formatMessage';
import { PresentationMode } from '../../../../../../../Enums/PresentationMode';
import { addressReducerTypes } from '../../Reducer';
import { addressFormId } from '../../CommonFunctions';
import SecondaryButton from '../../../../../../../Elements/ids/Buttons/SecondaryButton';
import ModalPrimaryButton from '../../../../../../../Elements/ids/Buttons/ModalPrimaryButton';

const AddressButtons = ({ canSubmit, modalMode, setModalMode, closeView, addressDispatch, addressState }) => {
  return (
    <>
      <SecondaryButton
        text={formatMessage(Messages.common_cancel)}
        onClickEvent={() => {
          if (
            modalMode !== PresentationMode.View &&
            modalMode !== PresentationMode.Error &&
            addressState.addressList.length !== 0 &&
            addressState.uneditedData
          ) {
            addressDispatch({
              type: addressReducerTypes.resetAddressState,
            });
            setModalMode(PresentationMode.View);
          } else {
            closeView();
          }
        }}
      />

      {(modalMode === PresentationMode.Edit || modalMode === PresentationMode.Add) && (
        <ModalPrimaryButton
          text={
            modalMode === PresentationMode.Edit
              ? formatMessage(Messages.common_update)
              : formatMessage(Messages.common_create)
          }
          canSubmit={canSubmit}
          formId={addressFormId}
        />
      )}
    </>
  );
};

export default AddressButtons;
